import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map'
})
export class MapPipe implements PipeTransform {

  transform(value: string, fn: (arg: any) => string): string {
    return fn(value);
  }
}
